/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { aiConfigsCreateVariation } from "../../funcs/aiConfigsCreateVariation.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.PostAIConfigVariationRequest$inboundSchema,
};

export const tool$aiConfigsCreateVariation: ToolDefinition<typeof args> = {
  name: "create-ai-config-variation",
  description:
    `Adds a new variation to an AI Config, supporting experimentation or multi-model strategies.
`,
  scopes: ["write"],
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await aiConfigsCreateVariation(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
